import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const get = async (id) => {
  return await axiosIns.get(obtenerUrl(`configuraciones/${id}`));
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`configuraciones/${id}`), data);
};

const idsUsuariosAutorizadosParaSedeGrupoCorporativo = async () => {
  return await axiosIns.get(obtenerUrl(`configuraciones/ids-usuarios-autorizados-sede-grupo-corporativo`));
};

export default {
  get,
  update,
  idsUsuariosAutorizadosParaSedeGrupoCorporativo,
};
